export const SearchResult = (data) => {
  const allResults = data
    .map(
      ({
        title,
        listMetadata: {
          summary = "descript test",
          readtime = "",
          thumbnail = `https://picsum.photos/seed/article${Math.random(0, 10)}/343/227`,
          articleTag = "Test category",
          url,
        },
      }) => {
        return `<li class="cards-articles__item">
         <a href="${url}" title="${title}">
            <div class="article__link">
                <div class="article__image-container">
                  <img class="article__image" src="${thumbnail}" alt="" />
                </div>
                <div class="article__content-wrapper">
                    <div class="article__top">
                        <div class="article-tags__wrapper">
                            <ul class="article-tags__listing">
                                <li class="article-tags__item">
                                    <span class="pills">${articleTag}</span>
                                </li>
                            </ul>
                        </div>
                        ${readtime ? `<div class="article__eta">${readtime} minute read</div>` : ""}
                    </div>

                    <div class="article__content">
                        <h3 class="article__title">${title}</h3>
                        <div class="article__description">
                            ${summary}
                        </div>
                    </div>
                </div>
            </div>
            </a>
        </li>`;
      }
    )
    .join("");
  return `<ul class="cards search-results__listing">${allResults}</u>`;
};

export const NoResults = (currated) => {
  const noResultsMessage = `Unfortunately, your search didn’t bring back any results`;
  const curratedList = currated
    .map(({ title, url }) => {
      return `<li><a class="button button--large button--border popular-searches__link" href="${url}"
                    title="${title}">${title}</a></li>`;
    })
    .join("");
  return `<div class="search-results__no-results">
        ${noResultsMessage}
    </div>
    <div class="popular-searches__container">
        <p class="body-large">Looking for something else?</p>
        <ul class="popular-searches">
            ${curratedList}
        </ul>
    </div>`;
};
